export const PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50, 100, 200];
